/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Folder,
  FolderRequestInput,
  ListFoldersParams,
  PaginatedFolders,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Folder
 */
export const createFolder = (
    folderRequestInput: MaybeRefOrGetter<FolderRequestInput>,
 signal?: AbortSignal
) => {
      folderRequestInput = toValue(folderRequestInput);

      return axiosClient<Folder>(
      {url: `/folders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: folderRequestInput, signal
    },
      );
    }




export const getCreateFolderMutationKey = () => ['createFolder'] as const;

export const getCreateFolderMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,CreateFolderMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,CreateFolderMutationVariables, TContext> => {

const mutationKey = getCreateFolderMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFolder>>, CreateFolderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFolder(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof createFolder>>>
    export type CreateFolderMutationBody = FolderRequestInput
    export type CreateFolderMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateFolderMutationVariables = {data: FolderRequestInput}

    /**
 * @summary Create Folder
 */
export const useCreateFolder = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,CreateFolderMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFolder>>,
        TError,
        CreateFolderMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFolderMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Folders
 */
export const listFolders = (
    params?: MaybeRefOrGetter<ListFoldersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedFolders>(
      {url: `/folders`, method: 'GET',
        params, signal
    },
      );
    }




export const getListFoldersQueryKey = (params?: MaybeRefOrGetter<ListFoldersParams>,) => {
    return [
    'folders', ...(params ? [params] : [])
    ] as const;
    }


export const getListFoldersQueryOptions = <TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListFoldersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFoldersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFolders>>> = ({ signal }) => listFolders(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>
}

export type ListFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof listFolders>>>
export type ListFoldersQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Folders
 */

export function useListFolders<TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListFoldersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFoldersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Folder
 */
export const deleteFolder = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/folders/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteFolderMutationKey = () => ['deleteFolder'] as const;

export const getDeleteFolderMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,DeleteFolderMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,DeleteFolderMutationVariables, TContext> => {

const mutationKey = getDeleteFolderMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFolder>>, DeleteFolderMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteFolder(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFolder>>>

    export type DeleteFolderMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteFolderMutationVariables = {id: string}

    /**
 * @summary Delete Folder
 */
export const useDeleteFolder = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,DeleteFolderMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteFolder>>,
        TError,
        DeleteFolderMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteFolderMutationOptions(options), queryClient);
    }
    /**
 * @summary Folder Details
 */
export const getFolder = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Folder>(
      {url: `/folders/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetFolderQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'folders',id
    ] as const;
    }


export const getGetFolderQueryOptions = <TData = Awaited<ReturnType<typeof getFolder>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetFolderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFolder>>> = ({ signal }) => getFolder(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>
}

export type GetFolderQueryResult = NonNullable<Awaited<ReturnType<typeof getFolder>>>
export type GetFolderQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Folder Details
 */

export function useGetFolder<TData = Awaited<ReturnType<typeof getFolder>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFolderQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Folder
 */
export const updateFolder = (
    id: MaybeRefOrGetter<string>,
    folderRequestInput: MaybeRefOrGetter<FolderRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
folderRequestInput = toValue(folderRequestInput);

      return axiosClient<Folder>(
      {url: `/folders/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: folderRequestInput, signal
    },
      );
    }




export const getUpdateFolderMutationKey = () => ['updateFolder'] as const;

export const getUpdateFolderMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFolder>>, TError,UpdateFolderMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFolder>>, TError,UpdateFolderMutationVariables, TContext> => {

const mutationKey = getUpdateFolderMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFolder>>, UpdateFolderMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateFolder(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof updateFolder>>>
    export type UpdateFolderMutationBody = FolderRequestInput
    export type UpdateFolderMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateFolderMutationVariables = {id: string;data: FolderRequestInput}

    /**
 * @summary Update Folder
 */
export const useUpdateFolder = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFolder>>, TError,UpdateFolderMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFolder>>,
        TError,
        UpdateFolderMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFolderMutationOptions(options), queryClient);
    }
